import { ComponentProps } from "react";
import { FeedReadingHistoryData } from "@pages/MyAccount/utils/types";
import Card from "@particles/card/Card";
import { getMetaDetails } from "@particles/card/utils/helpers";
import { getUrlQuery } from "@util/helpers";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

/**
 * Generates card properties for reading history articles and myBT.
 */
export const getMyAccountReadingHistoryCardsProps = (
  articles: FeedReadingHistoryData[],
  ref?: string
): ComponentProps<typeof Card>[] => {
  const linkParams = ref ? new URLSearchParams({ ref }) : undefined;

  const cardProps = articles.map(
    ({ articleId, title, publishedTime, articleUrl, sections }) => {
      const mainSection = sections?.[0];
      const _meta = getMetaDetails(mainSection);

      const props: ComponentProps<typeof Card> = {
        id: articleId,
        title,
        link: articleUrl + getUrlQuery(articleUrl, linkParams),
        updatedTime: publishedTime,
        meta: _meta,
      };

      return props;
    }
  );

  return JSON.parse(JSON.stringify(cardProps));
};
